<template>
    <tea-main @back="goBack">
        <template slot="nav">
            <div class="licenseWaitNav">
                <div class="main_wrap">
                    <div class="left">
                        <p class="zuxie-btn">待生成执照人员列表</p>
                        <p @click="$router.push('licenseList')" style="margin-left: 20px;cursor: pointer">已生成执照人员列表</p>
                    </div>
                    <div class="right">
                        <div class="zuxie-btn" v-if="userInfo.member_type === 'super'" style="margin-right: 20px" @click="handleTipsForStu" >一键处理待生成的学员执照</div>
                        <div class="zuxie-btn" @click="addPerson" >缺失库学员证照补发</div>
                    </div>
                </div>
            </div>
        </template>
        <template slot="main">
            <div class="licenseWaitMain">
                <div class="searchWrap">
                    <div class="search">
                        <div class="leisureBtn">
                            <select v-model="search.license_level"
                                    @change="changeUserType()"
                            >
                                <option value="">全部级别</option>
                                <option v-for="(item, index) in licenseWaitList"
                                        :key="index"
                                        :value="item.value">{{ item.key }}
                                </option>
                            </select>
                            <select v-model="search.license_type"
                                    @change="changeQuery(true)"
                            >
                                <option value="">全部类型</option>
                                <option v-for="(item, index) in licenseTypeList"
                                        :key="index"
                                        :value="item.value">{{ item.key }}
                                </option>
                            </select>
                        </div>
                        <div class="wrap">
                            <input v-model.lazy="search.keywords"
                                   type="text"
                                   placeholder="请输入搜索内容"
                                   @keyup.enter="getRequest">
                            <div v-show="search.keywords!=''"
                                 class="close"
                                 @click="hideIcon">
                                <v-icon name="regular/times-circle"
                                        scale="1.2"></v-icon>
                            </div>
                            <div class="searchBtn"
                                 @click="getRequest">搜索
                            </div>
                        </div>
                    </div>
                </div>
                <yioks-loading v-show="isLoading"></yioks-loading>
                <template v-if="!isLoading">
                    <template v-if="showList">
                        <div class="table">
                            <div class="thead">
                                <div class="tr">
                                    <div class="th index"><strong>序号</strong></div>
                                    <div class="th name"><strong>姓名</strong></div>
                                    <div class="th mobile_phone"><strong>手机号</strong></div>
                                    <div class="th id_number"><strong>身份证有效证件号</strong></div>
<!--                                    <div class="th banned_time"><strong>级别</strong></div>-->
                                    <div class="th user_type"><strong>级别</strong></div>
                                    <div class="th license_type"><strong>执照类型</strong></div>
                                    <div class="th opt"><strong>操作</strong></div>
                                </div>
                            </div>
                            <div class="scrollArea" v-if="showList">
                                <vue-scroll :ops="ops" ref="vs">
                                    <div class="tbodyWrap">
                                        <div class="tbody">
                                            <div class="tr"
                                                 v-for="(item, index) in list"
                                                 :key="index">
                                                <div class="td index">
                                                    <p >{{ index+1 }}</p>
                                                </div>
                                                <div class="td name">
                                                    <p >{{ item.name }}</p>
                                                </div>
                                                <div class="td mobile_phone">
                                                    <p>{{item.mobile_phone || '--'}}</p>
                                                </div>
                                                <div class="td id_number">
                                                    <p>{{ item.id_number||"--" }}</p>
                                                </div>
<!--                                                <div class="td banned_time">-->
<!--                                                    <p>{{item.end_date || '永久'}}</p>-->
<!--                                                </div>-->
                                                <div class="td user_type">
                                                    <p :title="item.license_level | level">{{item.license_level | level }}</p>
                                                </div>
                                                <div class="td license_type">
                                                    <p :title="item.license_type | licenseTypeFilter ">{{item.license_type | licenseTypeFilter }}</p>
                                                </div>
                                                <div class="td opt">
                                                    <span @click="lookOver(item.uid)" >查看</span>
                                                    <span>&nbsp;/&nbsp;</span>
                                                    <span @click="deleteOver(item.wait_id,index,item.name)">删除</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div id="paging">
                            <yioks-paging :paging="paging"
                                          @goto-page="gotoPage($event)"></yioks-paging>
                        </div>
                    </template>
                    <yioks-empty v-show="showEmpty"></yioks-empty>
                </template>
                <template v-if="showAddPerson">
                    <el-dialog
                            title="缺失库学员证照补发"
                            :visible.sync="showAddPerson"
                            :close-on-click-modal="false"
                            :close-on-press-escape="false"
                            width="450px"
                            custom-class="system_manager_dialog"
                            >
                        <el-form  :model="obj" ref="idNums">
                            <el-form-item prop="idNumberList" :rules="[{required:true,message:'请填写证件号',trigger:'blur'}]" >
                                <el-input type="textarea" v-model.trim="obj.idNumberList" rows="3" placeholder="请输入证件号，证件号之间用,分隔。例如：410725****5518,410726****5518"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="errMsg" v-if="showError" >
                            <p style="word-break: break-all;">提示：以下证件号<span style="color: red">{{errMsg}}</span>存在问题，无法添加。</p>
                            <p>原因可能有：个人信息未审核通过、已存在待生成名单、已是最新执照，无需重新生成。</p>
                        </div>
                        <div  class="btns" >
                            <el-button type="primary" @click="add" :disabled="addLoading" :loading="addLoading">添加</el-button>
                            <el-button type="cancel" @click="cancel">取消</el-button>
                        </div>
                    </el-dialog>
                </template>
                <yioks-dialog :showTips="showDeleteDialog" :tips="`确定删除${name}吗？`" :loading="wait_loading" @hideTips="hideDeleteTips"></yioks-dialog>
                <yioks-dialog :showTips="isShowTips" :tips="`是否确认请求吗？`"  @hideTips="handleConfirmAjax" :loading="tips_loading"></yioks-dialog>
            </div>
        </template>
    </tea-main>
</template>

<script>
    import {license_wait_list,license_wait_add,license_wait_remove, handleConfirmIdealStu} from "@/api/system_manager/api";
    import {licenseWaitList,classLevelListForCoachAndGoalkepperForLicense, licenseTypeList} from "@/assets/js/select";
    import {LevelFilters} from "@/assets/js/status";
    import ops from '@/assets/js/vuescrollOption';
    import { licenseTypeFilter } from '@/assets/js/yioksFilters';
    import {storageData} from "@/assets/js/storage";

    export default {
        name: "BlackList",
        data() {
            return {
                ops: ops(),
                // licenseWaitList,
                licenseWaitList: classLevelListForCoachAndGoalkepperForLicense.slice(1),
                licenseTypeList,
                addLoading:false,
                wait_id:'',
                wait_loading:false,
                obj:{
                    idNumberList:'',
                },
                index:0,
                showDeleteDialog:false,
                name:'',
                isLoading: true,
                showAddPerson:false,
                isShowTips: false,
                tips_loading: false,
                showList: false,
                showEmpty: false,
                list: [],
                Info:{},
                showError:false,
                errMsg:'',
                page: 1,
                paging: {
                    start: 0,
                    prePage: 1, // 一页多少条数据
                    total: 0, // 总页数
                    size: 3, // 页码显示限制
                    last: true, // 尾页
                    next: true, // 下一页
                    first: true, // 首页
                    previous: true, // 上一页
                    jump: true
                },
                search: {
                    keywords:'',
                    license_level:'',
                    license_type: '',
                },
            }
        },
        computed: {
            userInfo() {
                const userInfo = storageData.getUserInfo();
                return userInfo
            }
        },
        components: {
            "tea-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-paging": () => import("@/components/Pagination/Page"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "yioks-dialog" : () => import("@/components/Tips/Dialog"),
        },
        created() {
            this.setData();
            this.request();
        },
        filters: {
            licenseTypeFilter,
            userType(type){
                switch (type) {
                    case 'fakes' :return '假证';break;
                    case 'punish':return '处罚';break;
                }
            },
            level(type){
                return  LevelFilters(type)
            }
        },
        methods: {
            setData(){
                const {page,keywords,license_level, license_type} = this.$route.query;
                page && (this.page = page);
                keywords && (this.$set(this.search, "keywords", keywords));
                license_level && (this.$set(this.search, "license_level", license_level));
                license_type && (this.$set(this.search, "license_type", license_type));
            },
            goBack() {
                this.$router.push('sm');
            },
            lookOver(uid){
                this.$router.push({
                    path:'st',
                    query:{
                        id:uid
                    }
                })
            },
            delete(wait_id,index){
                this.wait_loading=true;
                license_wait_remove({
                    wait_id:wait_id
                }).then(res=>{
                    if (Number(res.data.status)===0) {
                        this.list.splice(index,1)
                        if (!this.list.length>0){
                            if (this.page===1){
                                this.changeQuery(true)
                            }else{
                                this.page-=1;
                                this.changeQuery(false)
                            }
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                    this.showDeleteDialog=false;
                    this.wait_loading=false;
                }).catch(err=>{
                    console.log(err)
                    // this.showDeleteDialog=false;
                    this.wait_loading=false;
                })
            },
            deleteOver(wait_id,index,name){
                this.showDeleteDialog=true;
                this.name=name
                this.wait_id=wait_id;
                this.index=index;
            },
            hideDeleteTips(bool,flag){
                if (flag){
                    this.delete(this.wait_id,this.index)
                }else {
                    this.showDeleteDialog=bool
                }
            },
            request() {
                this.isLoading = true;
                license_wait_list({"page": this.page, ...this.search})
                    .then(res=>{
                        if (res.data.status===0){
                            const {result} = res.data;
                            this.$set(this.paging, "prePage", result.page.page_size);
                            this.$set(this.paging, "total", result.page.total_row);
                            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                            this.list = result.list;
                            this.showList = result.list.length > 0;
                            this.showEmpty = !this.showList;
                            this.isLoading = false;
                        } else{
                            this.$message.error(res.data.msg);
                            this.isLoading = false;
                        }
                    })
                    .catch(err=>{
                        this.isLoading = false;
                        console.error(err);
                    })
            },
            addPerson(){
              this.showAddPerson=true;
            },
            handleTipsForStu() {
                this.isShowTips = true;
            },
            handleConfirmAjax(bool,ok) {
                if(ok) {
                    this.tips_loading = true;
                    handleConfirmIdealStu().then(res => {
                        
                        if(res.code) {
                            this.$message.error(res.msg);
                            return
                        }
                        this.tips_loading = false;
                        this.isShowTips = false
                    }).catch(err => {
                        this.tips_loading = false;
                        this.isShowTips = true;
                    
                    })
                }  else {
                    console.log('cancel tips')
                    this.isShowTips = false
                }
            },
            hideIcon() {
                this.$set(this.search, "keywords", "");
                this.getRequest();
            },
            changeUserType(){
                this.changeQuery(true)
            },
            getRequest() {
                this.changeQuery(true);
            },
            gotoPage: function (start) {
                this.page = parseInt(start / this.paging.prePage) + 1;
                this.changeQuery(false);
                this.$refs['vs'].scrollTo({ y: 0 });
            },
            changeQuery(flag) {
                flag && (this.page = 1);
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.page,
                        keywords: this.search.keywords,
                        license_level:this.search.license_level,
                        license_type:this.search.license_type,
                    }
                });
                this.request();
            },
            add(){
                this.$refs['idNums'].validate(validate=>{
                    if (validate){
                        this.addLoading=true;
                        license_wait_add({
                            id_number:this.obj.idNumberList.replace(/，/ig,',')
                        }).then(res=>{
                            if (Number(res.data.status)===0){
                                const {failUser}=res.data.result;
                                if ( failUser && failUser.length>0){
                                    this.showError=true;
                                    this.errMsg=failUser.join(',')
                                }else{
                                    this.$message.success('添加成功');
                                    this.showAddPerson=false;
                                    // this.obj.idNumberList='';
                                    // this.showAddPerson=false;
                                    // this.showError=false;
                                    // this.errMsg='';
                                }
                                this.addLoading=false;
                                this.changeQuery(true);
                            }else {
                                this.addLoading=false;
                                this.$message.error(res.data.msg)
                            }
                        }).catch(err=>{
                            this.addLoading=false;
                        })
                    } else{
                        this.$message.error('请填写证件号')
                    }
                })
            },
            cancel(){
              this.showAddPerson=false;
            },

        },
        watch:{
          showAddPerson:{
              handler(val){
                  if (!val){
                      this.showError=false;
                      this.errMsg='';
                      this.addLoading=false;
                      this.obj.idNumberList='';
                  }
              },
          }
        },
    }
</script>
<style lang="stylus">
    @import "~@/assets/css/variable";
    @import "~@/assets/css/base.styl";
    .reason_dialog_title {
        font-weight: bold;
        user-select: none;
        .title {
            color: $color_text_regular;
            font-size: 25px;
        }
        .subTitle {
            margin: 0 0 0 5px;
            color: $color_err;
            font-size: $font_size_medium;
        }
    }

</style>
<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    @import "~@/assets/css/mixin";
    @import "~@/assets/css/nav_filter";
    .licenseWaitNav, .licenseWaitMain {
        flex: 1 1 auto;
        height: 100%;
    }
    .licenseWaitNav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 0;
        font-size: $font_size_big;
        .main_wrap{
            display: flex
            flex: 1
            justify-content: space-between
            align-items: center
            .left, .right{
                display: flex
                align-items: center
                .btn{
                    padding: 5px 15px;
                    cursor: pointer;
                    &.active{
                        background-color: $color_suc;
                    }
                    &+.btn{
                        margin-left: 10px
                    }
                }
            }

        }


    }

    .licenseWaitMain {
        width: 100%;
        padding: 25px 0 0;
        background-color: $block_bg_color_base;
        .searchWrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            margin: 0 40px;
            .search {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap {
                    height: 100%;
                    display flex
                    position: relative;
                    input {
                        width: 220px;
                        height: 100%;
                        padding: 0 20px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                    }
                    .close {
                        position: absolute;
                        right: 95px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    .searchBtn {
                        width: 90px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        background-color: $color_suc;
                        cursor: pointer;

                    }
                }
                .leisureBtn{
                    position relative
                    display flex
                    height 100%
                    .close {
                        position: absolute;
                        right: 175px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    /*.timePicker{
                        border-radius 0
                        width 280px
                        margin-right 20px
                        span{
                            padding 0
                        }
                    }*/
                    select {
                        width: 150px;
                        height: 100%;
                        padding: 0 15px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        cursor pointer
                        outline: none;
                        &+select {
                            margin-left 15px
                        }
                    }
                }
            }
        }
        .table {
            width: 100%;
            margin: 30px 0 0;
            .thead, .tbody {
                border: 1px solid $color_white;
            }
            .thead {
                margin: 0 40px;
                .tr {
                    height: 45px;
                    display: flex;
                }
            }
            .scrollArea {
                height: 401px;
            }
            .tbodyWrap {
                display block
                margin-bottom 10px
                // padding: 0 40px;
            }
            .tbody {
                display block
                margin-left auto
                margin-right auto
                width: 810px;
                max-width: 810px;
                border-top: none;
                border-bottom: none;
                .tr {
                    height: 49px;
                    display: flex;
                    border-bottom: 1px solid $color_white;
                }
            }
            .th, .td {
                height: 100%;
                flex: 1 1 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                border-right: 1px solid $color_white;
            }
            .th:last-child, .td:last-child {
                border-right: none;
            }
            .td:last-child {
                color: $color_suc;
                user-select: none;
            }
            /*.td:first-child{
                color: $color_suc;
                user-select: none;
            }*/
            .td {
                p {
                    over_hide();
                }
                .showRecord{
                    cursor pointer
                }
            }
            .index {
                width: 6%;
            }
            .name {
                width: 13%;
            }
            .mobile_phone {
                width: 11%;
            }
            .id_number {
                width: 18%;
            }
            .banned_time {
                width: 15%;
            }
            .status {
                width: 10%;
            }
            .user_type{
                width 10%
            }
            .license_type{
                width 13%
            }
            .opt {
                width: 9%;
                span{
                    cursor: pointer;
                    color: $color_suc;
                }
            }
        }
        #paging {
            width: 100%;
            height: 77px;
        }
        .btns{
            display flex
            justify-content center
        }
        .errMsg{
            margin-bottom 10px

        }
    }
</style>

<style lang="stylus">
    .licenseWaitMain{
        .__vuescroll .__view{
            min-height 96%
        }
    }
</style>

